module.exports = __webpack_public_path__ + "static/media/experts.1f3d231a.jpg";